// @ts-nocheck
import * as React from "react"
import ProgressBar from 'react-customizable-progressbar'
import { SolutionSection, SolutionChart, ESImage } from "../config/interfaces";

import { useApi } from '../config/state'
import { ResponseSolutions } from '../types/api'

const MODIFIERCLASS: any = {
    Der: '',
    Izq: 'chart-desc--left',
    Only: 'chart-desc--only'
}

const ANIMATION: any = {
    Der: 'fade-right',
    Izq: 'fade-left',
    Only: 'fade-up'
}

export default ({ data }: { data?: SolutionSection | any }) => {
    return (
        <div className={`chart-desc${' ' + MODIFIERCLASS[data.chart_pos]}`}>
            <section className="chart-desc__body" data-aos={ANIMATION[data.chart_pos]}>
                <h2 className="chart-desc__title">{data.title}</h2>
                <div className="chart-desc__content" dangerouslySetInnerHTML={{ __html: data.desc }}></div>
            </section>
            {data.active == 1 && data.charts && data.charts.length > 0 && (
                data.chart_type === "bar_chart" ? (
                    // Gráficas de barra
                    <section
                        className="chart-desc__graph chart-desc__graph--bar"
                        data-aos={ANIMATION[data.chart_pos]}
                    >
                        {data.charts.map((charInfo: SolutionChart, indexChart: number) => (
                            <BarChart
                                key={indexChart}
                                chartData={charInfo}
                            />
                        ))}
                    </section>
                ) : (
                    // Gráficas circulares
                    <section
                        className="chart-desc__graph chart-desc__graph--circle"
                        data-aos={ANIMATION[data.chart_pos]}
                    >
                        {data.charts.map((charInfo: SolutionChart, indexChart: number) => (
                            <CircleChart
                                key={indexChart}
                                chartData={charInfo}
                                dataAos={ANIMATION[data.chart_pos]}
                            />
                        ))}
                    </section>
                )
            )}
        </div >
    )
}

declare var drupalSettings: any

const BarChart = ({ chartData }: { chartData: SolutionChart }) => {

    const [chartDataState, setChartDataState] = React.useState<SolutionChart>(chartData)

    // ==================== api ======================= //
    const dataApi = useApi((state: any) => state.data)
    React.useEffect(() => {
        if (Object.entries(dataApi).length === 0) return;

        drupalSettings.react.nodo.title.includes('Calera') && changeDataApi(dataApi as ResponseSolutions, 2)
        drupalSettings.react.nodo.title.includes('Apan') && changeDataApi(dataApi as ResponseSolutions, 1)
    }, [dataApi])

    const changeDataApi = (dataApi: ResponseSolutions, index: number) => {
        const chart = dataApi.data[index].sustainableAgriculture.conservationAgriculture.find(work => {
            return work.name.toLowerCase().includes(chartData.information.toLowerCase())
        })
        const label = dataApi.data[index].sustainableAgriculture.conservationAgriculture.find(lab => {
            // console.log(lab.name.toLowerCase());
            // console.log(chartData.label.toLowerCase());
            return chartData.label.toLowerCase().includes(lab.name.toLowerCase())
        })
        chart && setChartDataState({
            ...chartDataState,
            max_value: `${chart.projected}`,
            min_value: `${chart.current}`,
            label: `${label?.current} ${label?.name}`,
        })
    }
    // ================================================ //

    const refBarFill = React.useRef<any>(null)

    const calculatePercentage = (total: string, fill: string) => {
        if (parseInt(total) === 0) return 0
        return Math.round((parseInt(fill) * 100) / parseInt(total.replace(',', '')))
    }

    React.useEffect(() => {
        if (chartData.max_value === null) return
        refBarFill.current.dataset.progress = calculatePercentage(chartData.max_value, chartData.min_value)
    }, [chartData])

    return (
        <div className="bar-chart">
            {chartData.title && <div className="bar-chart__title" dangerouslySetInnerHTML={{ __html: chartData.title }}></div>}
            {chartData.label && <span className="bar-chart__tag" dangerouslySetInnerHTML={{ __html: chartData.label }}></span>}
            <div className="bar-chart__body">
                <p className="bar-chart__total">{chartData.max_value}</p>
                <div ref={refBarFill} className="bar-chart__fill">
                    <p className="bar-chart__progress">{Number(chartData.min_value).toFixed(2)}</p>
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 24 150 28" preserveAspectRatio="none">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(57, 189, 229,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(57, 189, 229,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(57, 189, 229,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#39BDE5" />
                        </g>
                    </svg>
                </div>
            </div>
            <div className='bar-chart__footer'>
                <p className='bar-chart__information'>{chartData.information}</p>
                {chartData.footer.map((legend: ESImage, indexLegend: number) => (
                    legend &&
                    <div className="bar-chart__legend" key={indexLegend} >
                        <object className="bar-chart__legend-image" width='58' height='58' data={legend?.url} type="image/svg+xml"></object>
                        <span className="bar-chart__legend-item" dangerouslySetInnerHTML={{ __html: legend?.alt }}></span>
                    </div>
                ))}
            </div>
        </div>
    )
}

const CircleChart = ({ chartData, dataAos }: { chartData: SolutionChart, dataAos: any }) => {
    const [progress, setProgress] = React.useState<number>(0)

    const calculatePercentage = (total: string, fill: string) => {
        return Math.round(parseInt(fill) * 100 / parseInt(total))
    }

    React.useEffect(() => {
        setProgress(calculatePercentage(chartData.max_value, chartData.min_value))
    }, [chartData])

    return (
        <div className='circle-chart' data-aos={dataAos}>
            <div className="circle-chart__title" dangerouslySetInnerHTML={{ __html: chartData.title }}></div>
            <ProgressBar
                progress={progress}
                radius={100}
                strokeWidth={35}
                strokeColor={'#39BDE5'}
                trackStrokeWidth={35}
                trackStrokeColor={'#4D75B4'}
                initialAnimation={true}>
                <div className="circle-chart__body">
                    <h2 className="circle-chart__percentage">{chartData.subtitle}</h2>
                    {chartData.label && <object width='55' height='55' data={chartData.label?.url} type="image/svg+xml"></object>}
                    <p className="circle-chart__subtitle">5 agricultores</p>
                </div>
            </ProgressBar>
            {chartData.footer.map((info: any, indexFooter: number) => info && <div className='float-footer' key={indexFooter}><object data={info?.url} type="image/svg+xml"></object>{info.alt}</div>)}
        </div>
    )
}